// src/com/auto_rotation_his/AutoRotationHisDict.js
import { TableColumnType } from "../../value/AppConst";

/**
 * AUTO_ROTATION_HIS React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2025-04-14 14:08:24 using DbdbTap
 * https://www.dbdbtap.com
 */
export const AutoRotationHisDictionary = {
    errorTitle: {
        Get: '배차 차종 통계 조회 오류',
    },
    tableProps: {
        tableId: 'autoRotationHisTable',
        uniqueKey: 'vehTypeId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //물류센터, 배차일자, 차종, 가용대수, 배차대수(당일), 배차대수(익일), 회전율, TOTAL, ~05시, 6시,....21시, 22시
            { id: 'dcName', label: '물류센터', width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'planDate', label: '배차일자', width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'vehTypeName', label: '차종', width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'usingCarCnt', label: '가용대수', width: 70, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'vehCnt', label: '배차대수(당일)', width: 100, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'nextDayVehCnt', label: '배차대수(익일)', width: 100, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'rotationRate', label: '회전율', width: 70, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            // total = vehCnt + nextDayVehCnt AS TOTAL, 조회 후 계산해 넣음.
            { id: 'total', label: 'TOTAL', width: 60, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'early5', label: '~05시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            //print using getTableColumnOption(c,t,i)
            { id: 'time06', label: '6시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time07', label: '7시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time08', label: '8시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time09', label: '9시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time10', label: '10시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time11', label: '11시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time12', label: '12시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time13', label: '13시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time14', label: '14시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time15', label: '15시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time16', label: '16시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time17', label: '17시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time18', label: '18시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time19', label: '19시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time20', label: '20시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time21', label: '21시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'time22', label: '22시', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
        ]
    },
};
